/**
 * Api request methods, endpoints and http codes
 */
const METHODS = {
  get: "GET",
  post: "POST",
  patch: "PATCH",
  put: "PUT",
  del: "DELETE",
};

const HTTP_CODES = {
  ok: 200,
  notFound: 404,
};

const ENDPOINT = {
  // Headset sale
  purchaseSummary: "/api/purchase/onboarding_headset/order-summary",
  startPayment: "/api/purchase/onboarding_headset/payment-start",
  confirmPayment: "/api/purchase/onboarding_headset/payment-confirm",

  // Premium sale
  premiumSummary: "/api/purchase/premium/order-summary",
  premiumStartPayment: "/api/purchase/premium/payment-start",
  premiumConfirmPayment: "/api/purchase/premium/payment-confirm",

  // Parent sale
  parentSummary: "/api/purchase/parents/order-summary",
  parentStartPayment: "/api/purchase/parents/payment-start",
  parentConfirmPayment: "/api/purchase/parents/payment-confirm",

  // Therapist client sale
  therapistClientSummary: "/api/purchase/therapist_plan/order-summary",
  therapistClientStartPayment: "/api/purchase/therapist_plan/payment-start",
  therapistClientConfirmPayment: "/api/purchase/therapist_plan/payment-confirm",

  // Country
  countries: "/api/unsecured/countries",
  countryStates: "/api/unsecured/states",
  countryDeliveryMethods: "/api/purchase/onboarding_headset/delivery-methods",

  // User
  registerUser: "/api/secured/users/register",
  userData: "/api/secured/users/get",
  authUser: "/api/secured/users/authenticate",
  addParentChildPhobias: "/api/secured/events/create", // Make sure you're using a secured https:// proxy for this endpoint.

  // Plans
  plans: "/api/secured/plans",
  allPlans: "/api/secured/maintenance/plans",

  // Referral
  referral: "/api/unsecured/referral_code",

  // Waiting List
  waitingList: "/api/secured/waiting_list/create",
};

export { METHODS, ENDPOINT, HTTP_CODES };
